import { Link, useLocation } from "react-router-dom";
import {
  ChevronDownIcon,
  Bars3Icon,
  XMarkIcon,
} from "@heroicons/react/20/solid";
import { useState, useEffect, useRef } from "react";

const Navbar = () => {
  const location = useLocation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Reference for the dropdown menu
  const dropdownRef = useRef(null);

  const handleDropdownToggle = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  // Close dropdown when clicking outside OR selecting an option
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Close dropdown when navigating to a new page
  useEffect(() => {
    setIsDropdownOpen(false);
  }, [location.pathname]);

  // CDN Image URL
  const CDN_URL = process.env.REACT_APP_CDN_URL;
  const logoUrl = `${CDN_URL}/global/Asset_3.png`;

  return (
    <nav className="sticky top-0 bg-white text-black shadow-md z-50">
      <div className="container mx-auto flex justify-between items-center px-6 sm:px-8 md:px-12 lg:px-16 xl:px-24 py-4">
        {/* Brand */}
        <Link to="/" className="flex items-center">
          <img src={logoUrl} alt="Brand Logo" className="h-12 w-auto" />
        </Link>

        {/* Mobile Menu Icon */}
        <button
          className="md:hidden focus:outline-none"
          onClick={handleMobileMenuToggle}
        >
          {isMobileMenuOpen ? (
            <XMarkIcon className="w-6 h-6" />
          ) : (
            <Bars3Icon className="w-6 h-6" />
          )}
        </button>

        {/* Desktop Links */}
        <div
          className={`flex-col md:flex-row md:flex items-center space-y-4 md:space-y-0 md:space-x-6 absolute md:static left-0 top-16 md:top-0 w-full md:w-auto bg-white md:bg-transparent z-20 md:z-auto ${
            isMobileMenuOpen ? "flex" : "hidden"
          }`}
        >
          <Link
            to="/about"
            className={`hover:text-secondary px-6 md:px-0 ${
              location.pathname === "/about"
                ? "text-secondary font-semibold"
                : ""
            }`}
          >
            About Us
          </Link>

          {/* Products Dropdown */}
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={handleDropdownToggle}
              className={`flex items-center space-x-1 hover:text-secondary px-6 md:px-0 ${
                ["/machine", "/software", "/print"].includes(location.pathname)
                  ? "text-secondary font-semibold"
                  : ""
              }`}
            >
              <span>Products</span>
              <ChevronDownIcon className="w-5 h-5" />
            </button>
            <div
              className={`absolute left-0 mt-2 w-44 bg-white text-black border border-gray-300 rounded-lg shadow-lg z-10 ${
                isDropdownOpen ? "block" : "hidden"
              }`}
            >
              <Link
                to="/machine"
                className={`block px-4 py-2 ${
                  location.pathname === "/machine"
                    ? "text-secondary font-semibold"
                    : ""
                } hover:bg-secondary hover:text-white rounded-t-lg`}
                onClick={() => setIsDropdownOpen(false)} // Close dropdown on selection
              >
                The wallPen
              </Link>
              <Link
                to="/software"
                className={`block px-4 py-2 ${
                  location.pathname === "/software"
                    ? "text-secondary font-semibold"
                    : ""
                } hover:bg-secondary hover:text-white`}
                onClick={() => setIsDropdownOpen(false)} // Close dropdown on selection
              >
                wallPen OS 3.0
              </Link>
              <Link
                to="/print"
                className={`block px-4 py-2 ${
                  location.pathname === "/print"
                    ? "text-secondary font-semibold"
                    : ""
                } hover:bg-secondary hover:text-white rounded-b-lg`}
                onClick={() => setIsDropdownOpen(false)} // Close dropdown on selection
              >
                Printing Services
              </Link>
            </div>
          </div>

          <Link
            to="/faq"
            className={`hover:text-secondary px-6 md:px-0 ${
              location.pathname === "/faq" ? "text-secondary font-semibold" : ""
            }`}
          >
            FAQ
          </Link>
          <Link
            to="/contact"
            className={`hover:text-secondary px-6 md:px-0 ${
              location.pathname === "/contact"
                ? "text-secondary font-semibold"
                : ""
            }`}
          >
            Contact
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
